export const queryKeys = {
  organization_features: 'organization_features',
  user_setting: 'user_setting'
};
